"use client";

import { cn, formatPhoneNumber } from "@/lib/utils/utils";
import { PhoneCall } from "lucide-react";
import { Separator } from "../ui/separator";
import { Link } from "@/i18n/routing";
import useLocalizer from "@/hooks/useLocalizer";
import Text from "./text";
import Flex from "../core/flex";

interface Props {
  className?: string;
  phoneNumber: string;
  image?: string;
}

const CallBox: React.FC<Props> = ({ className, phoneNumber, image }) => {
  const { t } = useLocalizer();
  return (
    <div className={cn("relative p-8", className)}>
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center bg-no-repeat bg-blend-overlay opacity-40 z-10"
        style={{ backgroundImage: `url('${image}')` }}
      />
      <div className="absolute top-0 left-0 w-full h-full bg-primary/70 z-20" />
      <div className="relative flex-1  flex flex-col items-center justify-center gap-4 z-30">
        <div className="h-20 w-20 bg-secondary text-white rounded-full flex items-center justify-center hover:bg-primary transition-colors">
          <PhoneCall size={30} />
        </div>
        <Text as="h2" className="text-2xl font-bold text-white">
          {t("titles.callRightNow")}
        </Text>
        <Text as="p" className="font-medium text-white text-center">
          {t("paragraphs.callUsDescription")}
        </Text>
      </div>
      <Separator className="relative z-30 mt-5 bg-muted/50" />
      <Flex
        direction="col"
        center
        spacing={{ all: 4 }}
        className="relative z-30 mt-10"
      >
        <Text as="span" className="text-xl text-white font-bold">
          {t("titles.callAnyTime")}
        </Text>
        <Link
          href={`tel:${phoneNumber}`}
          className="font-bold text-lg lg:text-xl text-white hover:text-secondary"
        >
          <Text bdi>
            {formatPhoneNumber(phoneNumber, "+(XXX)-XXXXXXXXX")}
          </Text>
        </Link>
      </Flex>
    </div>
  );
};

export default CallBox;
